import React, { useState, useEffect } from "react";
import { Button } from "components/common";
import { startCase, snakeCase } from "lodash";
import CreatableSelect from 'react-select/creatable';
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

const TAG_QUERY = gql`
                query GetAllUserTags {
                    getAllUserTags {
                    tags
                    }
                }
            `

const TagModal = ({ closeModal, setUserTags, resolveFraudTag, user, tag }) => {
    const [newTag, setNewTag] = useState();
    const [loading, setLoading] = useState(false);
    const { loading: tagsLoading, data: tagsData } = useQuery(TAG_QUERY);
    const [errorMessage, setErrorMessage] = useState("");
    const [commonTags, setCommonTags] = useState([]);

    const userTags = user.tags || [];

    const confirmFraud = () => {
        if (window.confirm("Confirming fraud for this user?")){
            resolveFraudTag({
                variables: {
                    user_id: user.email,
                    action: "CONFIRM_FRAUD"
                }
            })
            .then(res => {
                const { status, message } = ((res || {}).data || {}).resolveFraudTag || {};
                if (status === "OK") {
                    closeModal();
                    window.location.reload();
                } else {
                    setErrorMessage(message);
                };
            });
        }
    };

    const bypassFraud = () => {
        if (window.confirm("Bypass fraud check for this user?")){
            resolveFraudTag({
                variables: {
                    user_id: user.email,
                    action: "BYPASS_FRAUD"
                }
            })
            .then(res => {
                const { status, message } = ((res || {}).data || {}).resolveFraudTag || {};
                if (status === "OK") {
                    closeModal();
                    window.location.reload();
                } else {
                    setErrorMessage(message);
                };
            });
        };
    };

    const handleAddTag = (e) => {
        const tagToAdd = ((newTag || {}).value || "").trim();
        if (tagToAdd && window.confirm("Confirm to add?")){
            const payload = Array.from(new Set([...userTags, snakeCase(tagToAdd)]));
            setUserTags({
                variables: {
                    user_id: user.email,
                    tags: JSON.stringify(payload)
                }
            })
            .then(res => {
                const { status, message } = ((res || {}).data || {}).updateUserData || {};
                if (status === "OK"){
                    closeModal();
                    window.location.reload();
                } else {
                    setErrorMessage(message);
                };
            });
        };
    };

    const handleRemoveTag = () => {
        if (window.confirm("Are you sure about removing this tag?")){
            if (tag) setUserTags({
                variables: {
                    user_id: user.email,
                    tags: JSON.stringify(userTags.filter(t => t !== tag))
                }
            })
            .then(res => {
                const { status, message } = ((res || {}).data || {}).updateUserData || {};
                if (status === "OK") {
                    closeModal();
                    window.location.reload();
                } else {
                    setErrorMessage(message);
                };
            });
        };
    };

    const fetchCommonTags = async () => {
        const { tags = [] } = (tagsData || {}).getAllUserTags || {};
        if (tags.length) {
            const formattedTags = tags.map((item) => ({
                value: item,
                label: startCase(item)
            }));
            setCommonTags(formattedTags);
        };
    };

    useEffect(() => {
        if (!tagsLoading) fetchCommonTags();
    }, [tagsLoading]);

    const renderTagAction = () => {
        if (!tag){
            return (
                <div className="w-max">
                    <div className="mb-5 px-10 font-bold">Add New Tag</div>
                    <CreatableSelect
                        placeholder="Enter tags..."
                        className="w-full"
                        name="tags-modal"
                        options={commonTags}
                        value={newTag}
                        onChange={t => setNewTag(t)}
                    />
                    <div className={errorMessage ? "text-red-600 mb-4" : "hidden"}>
                        {errorMessage}
                    </div>
                    <Button
                        className={`my-6 w-full ${loading ? "opacity-50" : ""}`}
                        disabled={loading}
                        onClick={handleAddTag}
                    >
                        Submit
                    </Button>
                </div>
            );
        } else if (tag === 'potential_fraud'){
            let meta = (user || {}).metadata;
            if (meta && typeof meta === "string") meta = JSON.parse(meta);
            const fraudReason = (meta.fraud_reason || []).map((fr) => <li key={fr}>{fr}</li>);

            return (
                <div>
                    <div className="mb-5 font-bold">Potential Fraud</div>
                    <div className="mb-5">
                        {fraudReason}
                    </div>
                    <div className={errorMessage ? "text-red-600 mb-4" : "hidden"}>
                        {errorMessage}
                    </div>
                    <Button
                        className={`my-6 w-full ${loading ? "opacity-50" : ""}`}
                        disabled={loading}
                        onClick={bypassFraud}
                    >
                        Bypass Fraud Check
                    </Button>
                    <Button
                        className={`my-6 w-full ${loading ? "opacity-50" : ""}`}
                        disabled={loading}
                        onClick={confirmFraud}
                    >
                        Confirm Fraud
                    </Button>
                </div>

            );
        } else {
            return (
                <div>
                    <div className="mb-5"><span className="font-bold">Tag: </span>{tag}</div>
                    <div className={errorMessage ? "text-red-600 mb-4" : "hidden"}>
                        {errorMessage}
                    </div>
                    <Button
                        className={`my-6 w-full ${loading ? "opacity-50" : ""}`}
                        disabled={loading}
                        onClick={handleRemoveTag}
                    >
                        Remove
                    </Button>
                </div>
            );
        };
    };

    return (
        <div style={{ backgroundColor: "#FAFAFA" }} className="py-8 px-12">
            {renderTagAction()}
        </div>
    )
};

export default TagModal;
